module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    attrs: {
      "id": "order-details"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryOptionsErrors.parts),
      expression: "deliveryOptionsErrors.parts"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Prosimy o dodanie przynajmniej jednego numeru zamówienia wraz z jego wartością.")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('div', {
    staticClass: "option-container"
  }, [_vm._l((_vm.threeAvailableDates), function(d, index) {
    return _c('div', {
      staticClass: "option4 order-promoted-option",
      class: {
        'option-active': d.date == _vm.currentDate.date
      },
      on: {
        "click": function($event) {
          return _vm.selectDate(d);
        }
      }
    }, [_c('h5', [_vm._v(_vm._s(d.date))]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(d.dayName) + ")")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "option4",
    class: {
      'option-active': _vm.showAllDates == true
    },
    on: {
      "click": function($event) {
        return _vm.clickAllDates()
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.otherDates.date))]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.otherDates.note) + ")")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllDates),
      expression: "showAllDates"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selDate),
      expression: "selDate"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selDate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Wybierz preferowany dzień dostawy")]), _vm._v(" "), _vm._l((_vm.availableDates), function(d) {
    return _c('option', {
      domProps: {
        "selected": _vm.currentDate,
        "value": d.date
      }
    }, [_vm._v(_vm._s(d.date) + " (" + _vm._s(d.dayName) + ")")])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryOptionsErrors.date),
      expression: "deliveryOptionsErrors.date"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Prosimy o wybór preferowanego dnia dostawy.")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "formFieldWrap"
  }, [_c('div', {
    staticClass: "option-container"
  }, [_c('div', {
    staticClass: "option4 order-promoted-option",
    class: {
      'option-active': _vm.currentTimePeriod == _vm.timePeriods[0]
    },
    on: {
      "click": function($event) {
        return _vm.setTimePeriod(0);
      }
    }
  }, [_c('svg', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M42,14.1c0,1.7,0.4,3.3,1.2,4.6l8.1-4.7V4.8C46.2,4.8,42,9,42,14.1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M51.4,0c-7.8,0-14.2,6.3-14.2,14.1s6.4,14.2,14.2,14.2s14.2-6.4,14.2-14.2C65.5,6.3,59.2,0,51.4,0z M60.6,18.6\n\t\t\t\t\t\t\t\t\t\t\tc-0.2,0.4-0.5,0.9-0.7,1.3l0.9,0.5c-0.9,1.3-2,2.4-3.3,3.2L57,22.7c-0.2,0.1-0.4,0.3-0.7,0.4l0.5,0.9c-1.4,0.7-2.9,1.2-4.5,1.3v-1\n\t\t\t\t\t\t\t\t\t\t\tc-0.2,0-0.5,0-0.7,0c-0.2,0-0.5,0-0.7,0v1c-1.6-0.1-3.1-0.6-4.5-1.3l0.5-0.9c-0.2-0.1-0.5-0.3-0.7-0.4l-0.5,0.9\n\t\t\t\t\t\t\t\t\t\t\tc-1.3-0.8-2.5-2-3.4-3.3l0.9-0.5c-0.5-0.3-0.8-0.8-1-1.2l-0.9,0.5c-0.7-1.4-1.1-2.9-1.1-4.5h1c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.4\n\t\t\t\t\t\t\t\t\t\t\th-1c0.1-1.6,0.5-3.2,1.1-4.6l0.9,0.5c0.2-0.4,0.5-0.9,0.7-1.3l-0.8-0.5c0.9-1.3,2-2.4,3.3-3.2l0.5,0.9c0.2-0.1,0.4-0.3,0.7-0.4\n\t\t\t\t\t\t\t\t\t\t\tl-0.5-0.9C47.5,3.6,49,3.1,50.6,3v1c0.2,0,0.5,0,0.7,0c0.3,0,0.5,0,0.7,0V3c1.6,0.1,3.1,0.6,4.5,1.3L56,5.2\n\t\t\t\t\t\t\t\t\t\t\tc0.2,0.1,0.5,0.3,0.7,0.4l0.5-0.9c1.3,0.8,2.5,2,3.4,3.3l-0.9,0.5c0.3,0.4,0.5,0.8,0.7,1.3l0.9-0.5c0.7,1.4,1.1,2.9,1.1,4.5h-1\n\t\t\t\t\t\t\t\t\t\t\tc0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.4h1c-0.1,1.6-0.5,3.2-1.1,4.6L60.6,18.6z"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.timePeriods[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "option4 order-promoted-option",
    class: {
      'option-active': _vm.currentTimePeriod == _vm.timePeriods[1]
    },
    on: {
      "click": function($event) {
        return _vm.setTimePeriod(1);
      }
    }
  }, [_c('svg', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M56.2,6.1c-1.5-0.8-3-1.2-4.6-1.3v9.4l8,4.6C62.2,14.4,60.5,8.6,56.2,6.1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M63.7,21.2c3.9-6.8,1.6-15.5-5.2-19.4S43.1,0.3,39.2,7.1c-3.9,6.7-1.6,15.4,5.2,19.3S59.8,28,63.7,21.2z\n\t\t\t\t\t\t\t\t\t\t\t M43,19.9c-0.2-0.4-0.5-0.9-0.7-1.3l-0.9,0.5c-0.7-1.4-1.1-2.9-1.1-4.5h1c0-0.3,0-0.5,0-0.8h-1c0-1.6,0.4-3.1,1.1-4.6l0.9,0.5\n\t\t\t\t\t\t\t\t\t\t\tc0.1-0.2,0.2-0.4,0.3-0.7c0.1-0.2,0.3-0.4,0.4-0.6l-0.8-0.5c0.9-1.3,2-2.4,3.3-3.2L46,5.6c0.2-0.1,0.5-0.3,0.7-0.4l-0.5-0.9\n\t\t\t\t\t\t\t\t\t\t\tC47.5,3.6,49,3.1,50.7,3v1c0.5,0,1,0,1.5,0V3c1.5,0.1,3,0.5,4.5,1.3l-0.5,0.9c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.1,0.3,0.2\n\t\t\t\t\t\t\t\t\t\t\tl0.5-0.9c1.4,0.9,2.5,2,3.4,3.3l-0.9,0.5c0.3,0.4,0.5,0.8,0.7,1.3l0.9-0.5c0.7,1.4,1.1,2.9,1.1,4.5h-1c0,0.3,0,0.5,0,0.8h1\n\t\t\t\t\t\t\t\t\t\t\tc0,1.6-0.4,3.1-1.1,4.6l-0.9-0.5c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.6l0.9,0.5c-0.9,1.3-2,2.4-3.3,3.2L57,22.8\n\t\t\t\t\t\t\t\t\t\t\tc-0.2,0.1-0.5,0.3-0.7,0.4l0.5,0.9c-1.4,0.7-2.9,1.2-4.5,1.3v-1c-0.5,0-1,0-1.5,0v1c-1.5-0.1-3-0.5-4.5-1.3l0.5-0.9\n\t\t\t\t\t\t\t\t\t\t\tc-0.1-0.1-0.2-0.1-0.4-0.2c-0.1-0.1-0.2-0.1-0.3-0.2l-0.5,0.9c-1.4-0.9-2.5-2-3.4-3.3L43,19.9z"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.timePeriods[1]))])]), _vm._v(" "), _c('div', {
    staticClass: "option4 order-promoted-option",
    class: {
      'option-active': _vm.currentTimePeriod == _vm.timePeriods[2]
    },
    on: {
      "click": function($event) {
        return _vm.setTimePeriod(2);
      }
    }
  }, [_c('svg', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M56,22.2c1.5-0.8,2.6-2,3.4-3.4l-8.1-4.7l-8,4.6C45.9,23.3,51.6,24.8,56,22.2z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M39.1,21.2c3.9,6.8,12.6,9.1,19.4,5.2S67.6,13.8,63.7,7c-4-6.7-12.6-9-19.4-5.1S35.2,14.5,39.1,21.2z M50.6,4\n\t\t\t\t\t\t\t\t\t\t\tc0.5,0,1,0,1.5,0V3c1.6,0.1,3.1,0.5,4.5,1.3l-0.5,0.9c0.2,0.1,0.5,0.3,0.7,0.4l0.5-0.9c1.3,0.8,2.5,1.9,3.4,3.3l-0.9,0.5\n\t\t\t\t\t\t\t\t\t\t\tc0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.3,0.7l0.9-0.5c0.7,1.4,1.1,3,1.1,4.5h-1c0,0.3,0,0.5,0,0.8h1c-0.1,1.6-0.4,3.1-1.1,4.6\n\t\t\t\t\t\t\t\t\t\t\tl-0.9-0.5c-0.2,0.4-0.5,0.9-0.7,1.3l0.9,0.5c-0.8,1.3-2,2.4-3.3,3.2l-0.5-0.9c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2\n\t\t\t\t\t\t\t\t\t\t\tl0.5,0.9c-1.4,0.8-3,1.2-4.5,1.3v-1c-0.5,0-1,0-1.5,0v1c-1.6-0.1-3.1-0.5-4.5-1.3l0.5-0.9c-0.2-0.1-0.5-0.3-0.7-0.4l-0.5,0.9\n\t\t\t\t\t\t\t\t\t\t\tc-1.3-0.8-2.5-1.9-3.4-3.3l0.9-0.5c-0.1-0.2-0.3-0.4-0.4-0.6c-0.2-0.2-0.3-0.4-0.4-0.6l-0.9,0.5c-0.7-1.4-1.1-3-1.1-4.5h1\n\t\t\t\t\t\t\t\t\t\t\tc0-0.3,0-0.5,0-0.8h-1c0.1-1.6,0.4-3.1,1.1-4.6l0.9,0.5c0.2-0.4,0.5-0.9,0.7-1.3l-0.8-0.5c0.8-1.3,2-2.4,3.3-3.2l0.5,0.9\n\t\t\t\t\t\t\t\t\t\t\tc0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.5-0.9c1.4-0.8,3-1.2,4.5-1.3V4z"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.timePeriods[2]))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "option4 order-promoted-option",
    class: {
      'option-active': _vm.currentTimePeriod == _vm.timePeriods[3]
    },
    on: {
      "click": function($event) {
        return _vm.setTimePeriod(3);
      }
    }
  }, [_c('svg', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M39.1,21.2c3.9,6.8,12.6,9.1,19.4,5.2S67.6,13.8,63.7,7c-4-6.7-12.6-9-19.4-5.1S35.2,14.5,39.1,21.2z M50.6,4\n\t\t\t\t\t\t\t\t\t\t\tc0.5,0,1,0,1.5,0V3c1.6,0.1,3.1,0.5,4.5,1.3l-0.5,0.9c0.2,0.1,0.5,0.3,0.7,0.4l0.5-0.9c1.3,0.8,2.5,1.9,3.4,3.3l-0.9,0.5\n\t\t\t\t\t\t\t\t\t\t\tc0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.3,0.7l0.9-0.5c0.7,1.4,1.1,3,1.1,4.5h-1c0,0.3,0,0.5,0,0.8h1c-0.1,1.6-0.4,3.1-1.1,4.6\n\t\t\t\t\t\t\t\t\t\t\tl-0.9-0.5c-0.2,0.4-0.5,0.9-0.7,1.3l0.9,0.5c-0.8,1.3-2,2.4-3.3,3.2l-0.5-0.9c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2\n\t\t\t\t\t\t\t\t\t\t\tl0.5,0.9c-1.4,0.8-3,1.2-4.5,1.3v-1c-0.5,0-1,0-1.5,0v1c-1.6-0.1-3.1-0.5-4.5-1.3l0.5-0.9c-0.2-0.1-0.5-0.3-0.7-0.4l-0.5,0.9\n\t\t\t\t\t\t\t\t\t\t\tc-1.3-0.8-2.5-1.9-3.4-3.3l0.9-0.5c-0.1-0.2-0.3-0.4-0.4-0.6c-0.2-0.2-0.3-0.4-0.4-0.6l-0.9,0.5c-0.7-1.4-1.1-3-1.1-4.5h1\n\t\t\t\t\t\t\t\t\t\t\tc0-0.3,0-0.5,0-0.8h-1c0.1-1.6,0.4-3.1,1.1-4.6l0.9,0.5c0.2-0.4,0.5-0.9,0.7-1.3l-0.8-0.5c0.8-1.3,2-2.4,3.3-3.2l0.5,0.9\n\t\t\t\t\t\t\t\t\t\t\tc0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.5-0.9c1.4-0.8,3-1.2,4.5-1.3V4z"
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("08:00 - 20:00")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryOptionsErrors.period),
      expression: "deliveryOptionsErrors.period"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Prosimy o wybór preferowanego przedziału godzinowego dostawy.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-android-calendar"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybierz preferowany dzień dostawy")]), _vm._v(" "), _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "disclaimer"
  }, [_vm._v("UWAGA: Wybrany termin oznacza preferowany dzień dostawy, który może ulec zmianie w toku planowania. W przypadku zaistnienia takiej sytuacji pracownik POK skontaktuje się telefonicznie w celu umówienia ostatecznego terminu realizacji.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-android-time"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybierz przedział godzinowy dostawy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-513b50f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderDetails.vue
// module id = 253
// module chunks = 1